<app-transaction-result-view
[title]="title"
[subtitle]="subtitle"
[message]="message"
[messageBold]="messageBold"
[variant]="variant"
[showButtonAction]="true"
[breadcrums]="breadcrums"
[actionButtonPath]="actionButtonPath"
[actionButtonText]="actionButtonText"
></app-transaction-result-view>
 